import { useState, useEffect } from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";
import TalentCard from "./TalentCard";
import { Loading } from "../Other/Loading";

const TalentPipeline = () => {
  const { t } = useTranslation();
  const [data, setData] = useState(null);

 
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_LOGIN_API_BASEURL}/json-page/name/talents`);
        //console.log("API Response:", response.data); // Log response to debug
        const events = JSON.parse(response.data);
        console.log("API Response:", events);
        setData(events);  // turns string into array of objects
      }
      catch (error) {
        console.error("Error fetching reasons data:", error);
      }
    };

    fetchData();
  }, []);


  if (!data) {
    return <div className=""><Loading /></div>;
  }

  return (
    <div className="relative min-h-screen overflow-hidden bg-white"
    style={{ backgroundImage: "url('/image/Talent_Bg.avif')", backgroundSize: "cover", backgroundPosition: "center" }} 
    >
      {/* Background Pattern */}
      <div className="!absolute inset-0 opacity-10">
        {[...Array(10)].map((_, i) => (
          <div
            key={i}
            className="!absolute w-full h-24 transform -skew-y-6"
            style={{
              top: `${i * 10}%`,
              left: 0,
              background:
                "linear-gradient(90deg, transparent, rgba(255,255,255,0.1) 50%, transparent)",
            }}
          />
        ))}
      </div> 

      <div className="container mx-auto px-4 py-16 my-4">
        {/* Heading */}
        <h1 className="text-2xl text-center font-bold mb-16 max-w-3xl mx-auto ">
          {t(
            "Building a Future-Ready Workforce: Developing Talent Pipelines and Digital Mastery"
          )}
        </h1>

        {/* Cards */}
        <div className=" mx-auto space-y-8 md:space-y-12">
          {data.cards.map((card, index) => (
            <TalentCard key={card.id} {...card} index={index} />
          ))}
        </div>

        {/* Learn More Button */}
        <div className="text-center mt-12">
          <button className="bg-blue-500 hover:bg-blue-600 text-white font-semibold py-3 px-8 rounded-lg transition-colors duration-300">
            {t("Learn more")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default TalentPipeline;
